import * as MbProductAction from './mb-product.action'
export { MbProductAction }
